import { isEmpty, size } from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  SELECT_ALL_LABEL,
  TALENT_FILTERS,
  TALENT_FILTER_OPTIONS,
} from '../../../../../../../utils/constants';
import DropdownFilterTalentBuilder from '../DropdownFilterTalentBuilder/DropdownFilterTalentBuilder';
import data from './data.json';

let tempFilter = {
  top_talent_status: [],
  business: [],
  salary_grade: [],
  other_experience: [],
  personality: [],
  age: [],
  business_experience: [],
  years_in_position: [],
  nationality: [],
  state_of_birth: [],
  years_to_retire: [],
  gender: [],
  functional_experience: [],
  edge: [],
  successor: [],
  attr27: [],
};

let filterTabActive = [];
let preTalentFilterOptions = {};
const FilterFinderTalentBuilder = (props) => {
  const { filterOptions, setFilterFinderData, setIsFilter } = props;
  const [isBlur, setIsBlur] = useState(false);
  const [talentFilterOptions, setTalentFilterOptions] = useState({});

  const cloneState = (state) => {
    return JSON.parse(JSON.stringify(state));
  };

  const updateStateData = (filterName, options, newData) => {
    tempFilter[filterName] = options;
    setTalentFilterOptions(newData);
  };

  const onChange = (currentNode) => {
    const filterName = currentNode.path.split('.')[0];
    let indexArr = getIndexList(currentNode.path);

    const newData = cloneState(talentFilterOptions);
    let options = newData[filterName];
    let selectedOption;
    const optionParentLv2 = options[indexArr[0]];
    const handleCheckedParent = (parentOption) => {
      const optionsChecked = parentOption.children.filter((optionLv2) => {
        return optionLv2.checked === true;
      });
      if (optionsChecked.length > 0) {
        parentOption.checked = true;
      } else {
        parentOption.checked = false;
      }
    };
    switch (indexArr.length) {
      case 1: //onChange lv1 of dropdown select tree
        selectedOption = options[indexArr[0]];
        selectedOption.checked = currentNode.checked;
        selectedOption.expanded = true;
        options.forEach((option) => {
          if (option.label !== currentNode.label) {
            option.expanded = false;
            if (option.children?.length) {
              option.children.forEach((childItem) => {
                childItem.expanded = false;
              });
            }
          }
        });
        if (selectedOption.children?.length) {
          selectedOption.children.forEach((childOption) => {
            childOption.checked = currentNode.checked;
            childOption.expanded = true;
            if (childOption.children?.length) {
              childOption.children.forEach((i) => {
                i.checked = currentNode.checked;
              });
            }
          });
        }
        break;

      case 2: //onChange lv2 of dropdown select tree
        selectedOption = options[indexArr[0]].children[indexArr[1]];
        selectedOption.checked = currentNode.checked;
        selectedOption.expanded = true;
        if (selectedOption.children?.length) {
          selectedOption.children.forEach((childOption) => {
            childOption.checked = currentNode.checked;
          });
        }
        handleCheckedParent(optionParentLv2);
        break;

      case 3: //onChange lv3 of dropdown select tree
        selectedOption = options[indexArr[0]].children[indexArr[1]].children[indexArr[2]];
        selectedOption.checked = currentNode.checked;
        const optionParentLv3 = options[indexArr[0]]?.children[indexArr[1]];
        handleCheckedParent(optionParentLv3);
        handleCheckedParent(optionParentLv2);
        break;
      default:
    }

    const allKeys = getAllKeys(options);
    const tempUncheckedItem = allKeys.filter(
      (item) => !item.checked && item.label !== SELECT_ALL_LABEL
    );
    if (tempUncheckedItem.length > 0) {
      options[0].checked = false;
    } else {
      options[0].checked = true;
    }
    updateStateData(filterName, options, newData);
  };

  const getAllKeys = (tree) => {
    let result = [];
    tree.forEach((item) => {
      let childKeys = [];
      if (item?.children) {
        childKeys = getAllKeys(item.children);
      }
      result.push(...[{ label: item?.label, checked: item?.checked }, ...childKeys]);
    });

    return result;
  };

  const onClickSelectAll = (filterName, isChecked) => {
    const newData = cloneState(talentFilterOptions);
    assignObjectPaths(newData[filterName], filterName, isChecked);
    updateStateData(filterName, newData[filterName], newData);
  };

  const onNodeToggle = (currentNode) => {
    const filterName = currentNode.path.split('.')[0];
    let indexArr = getIndexList(currentNode.path);
    const newData = cloneState(talentFilterOptions);
    const options = newData[filterName];
    let currentOption;

    const handleExpandChild = (option, isExpanded) => {
      if (option.children?.length) {
        option.children.forEach((childItem) => {
          childItem.expanded = isExpanded;
        });
      }
    };

    switch (indexArr.length) {
      case 1: //Expand level 1
        currentOption = options[indexArr[0]];

        if (currentNode.expanded) {
          currentOption.expanded = true;

          options.forEach((option) => {
            if (option.label !== currentNode.label) {
              option.expanded = false;
            }
            handleExpandChild(option, false);
          });

          handleExpandChild(currentOption, true);
        } else {
          currentOption.expanded = false;
          handleExpandChild(currentOption, false);
        }
        break;
      case 2: //Expand level 2
        currentOption = options[indexArr[0]].children[indexArr[1]];

        if (!currentNode.expanded) {
          currentOption.expanded = false;
        } else {
          currentOption.expanded = true;
        }
        break;
      default:
    }

    updateStateData(filterName, options, newData);
  };

  const getIndexList = (path) => {
    if (!path.includes('.')) return [];

    let tempArr = path.match(/\.\d+/g);
    tempArr =
      size(tempArr) > 0
        ? tempArr.map((item) => {
            return `${item.replace('.', '')}`;
          })
        : [];
    return tempArr;
  };

  const assignObjectPaths = (obj, stack, isChecked) => {
    Object.keys(obj).forEach((k) => {
      const node = obj[k];
      if (typeof node === 'object') {
        if (!stack && node[0]?.label !== SELECT_ALL_LABEL) {
          node.unshift({
            label: SELECT_ALL_LABEL,
            checked: isChecked === undefined ? true : isChecked,
          });
        }
        node.path = stack ? `${stack}.${k}` : k;
        node.checked = isChecked === undefined ? true : isChecked;
        assignObjectPaths(node, node.path, isChecked);
      }
    });
  };

  const handleClickApplyFilter = (item, key) => {
    if (size(tempFilter[key]) <= 0) {
      tempFilter[key] = item;
    }

    if (!filterTabActive.includes(key)) {
      filterTabActive.push(key);
    }

    const dataToPost = getDataToPost();
    setFilterFinderData(dataToPost);
    preTalentFilterOptions = cloneState(talentFilterOptions);
    setIsFilter(true);
  };

  const handleClearFilter = () => {
    Object.keys(tempFilter).forEach((key) => {
      tempFilter[key] = [];
    });
    filterTabActive = [];
    setIsFilter(false);
    setFilterFinderData({});
    assignObjectPaths(data);
    assignObjectPaths(filterOptions);
    setTalentFilterOptions({ ...filterOptions, ...data });
    preTalentFilterOptions = { ...filterOptions, ...data };
  };

  const getDataToPost = () => {
    const top_talent_status = handleGetFilterData(TALENT_FILTER_OPTIONS.TOP_TALENT_STATUS);
    const business_unit = handleGetFilterData(TALENT_FILTER_OPTIONS.BUSINESS);
    const sg = tempFilter[TALENT_FILTER_OPTIONS.SALARY_GRADE];
    const experience_gtky = handleGetFilterData(TALENT_FILTER_OPTIONS.OTHER_EXPERIENCE);
    const personality_archetype = tempFilter[TALENT_FILTER_OPTIONS.PERSONALITY];
    const age_range = handleGetFilterData(TALENT_FILTER_OPTIONS.AGE);
    const business = handleGetFilterData(TALENT_FILTER_OPTIONS.BUSINESS_EXPERIENCE);
    const previous_business_experience = handleGetFilterData(
      TALENT_FILTER_OPTIONS.PREVIOUS_BUSINESS_EXPERIENCE
    );
    const years_in_position = handleGetFilterData(TALENT_FILTER_OPTIONS.YEARS_IN_POSITION);
    const years_to_retirement = handleGetFilterData(TALENT_FILTER_OPTIONS.YEARS_TO_RETIRE);
    const nationality = handleGetFilterData(TALENT_FILTER_OPTIONS.NATIONALITY);
    const state_of_birth = handleGetFilterData(TALENT_FILTER_OPTIONS.STATE_OF_BIRTH);
    const gender = handleGetFilterData(TALENT_FILTER_OPTIONS.GENDER);
    const successor = tempFilter[TALENT_FILTER_OPTIONS.SUCCESSOR];
    const functional_experience = tempFilter[TALENT_FILTER_OPTIONS.FUNCTIONAL_EXPERIENCE];
    const previous_functional_experience =
      tempFilter[TALENT_FILTER_OPTIONS.PREVIOUS_FUNCTIONAL_EXPERIENCE];
    const edge = tempFilter[TALENT_FILTER_OPTIONS.EDGE];
    const attr27 = tempFilter[TALENT_FILTER_OPTIONS.ATTRIBUTES];
    return {
      top_talent_status,
      business_unit,
      sg,
      experience_gtky,
      personality_archetype,
      age_range,
      business,
      previous_business_experience,
      years_in_position,
      years_to_retirement,
      nationality,
      state_of_birth,
      gender,
      successor,
      functional_experience,
      previous_functional_experience,
      edge,
      attr27,
    };
  };

  const handleGetFilterData = (filterName) => {
    return tempFilter[filterName]
      ? tempFilter[filterName].filter((d) => d.checked).map((item) => item.value)
      : [];
  };

  const handleReturnNumberColumns = (key) => {
    if (
      [
        TALENT_FILTER_OPTIONS.BUSINESS_EXPERIENCE,
        TALENT_FILTER_OPTIONS.PREVIOUS_BUSINESS_EXPERIENCE,
        TALENT_FILTER_OPTIONS.FUNCTIONAL_EXPERIENCE,
        TALENT_FILTER_OPTIONS.PREVIOUS_FUNCTIONAL_EXPERIENCE,
        TALENT_FILTER_OPTIONS.OTHER_EXPERIENCE,
      ].includes(key)
    ) {
      return 4;
    } else {
      return 2;
    }
  };
  const onBlur = (item, key) => {
    talentFilterOptions[key] = item;
    setTalentFilterOptions(preTalentFilterOptions);
    setIsBlur(true);
  };

  useEffect(() => {
    if (!isEmpty(filterOptions)) {
      assignObjectPaths(data);
      assignObjectPaths(filterOptions);
      setTalentFilterOptions({ ...filterOptions, ...data });
      preTalentFilterOptions = { ...filterOptions, ...data };
    }

    //  Handle clean the state
    return () => {
      handleClearFilter();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOptions]);
  return (
    <div className={'filter_section row px-0'}>
      {!isEmpty(talentFilterOptions) &&
        TALENT_FILTERS.map((item) =>
          Object.keys(talentFilterOptions).map((key, index) => {
            if (item.value === key) {
              return (
                <DropdownFilterTalentBuilder
                  key={`${key}.${index}`}
                  keyWord={key}
                  isBlur={isBlur}
                  onApply={() => handleClickApplyFilter(talentFilterOptions[key], key)}
                  filterName={key}
                  columns={handleReturnNumberColumns(key)}
                  onChange={onChange}
                  onNodeToggle={onNodeToggle}
                  onBlur={() => onBlur(talentFilterOptions[key], key)}
                  onClickSelectAll={(isChecked) => onClickSelectAll(key, isChecked)}
                  filterTabActive={filterTabActive}
                  label={item.label}
                  placeholder={item.label}
                  data={talentFilterOptions[key]}
                />
              );
            }
            return null;
          })
        )}
      {size(filterTabActive) > 0 && (
        <div className="col-12 px-0">
          <button onClick={handleClearFilter} className="clear_filter_button">
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default FilterFinderTalentBuilder;
